const isMockup =
  new URLSearchParams(window.location.search).get("mockup") === "true";

document.documentElement.classList.toggle("mockup", isMockup);

class TegelOptions extends HTMLElement {
  connectedCallback() {
    this.innerHTML = /* html */ `
        <div class="js-toggle-for-material d-none" data-material="tegel">
            <p>
            <strong data-i18n="components.productOptions.chooseSize">Kies je formaat</strong>
            </p>
            <div class="js-poster-size d-flex mb-4">
            <div
                class="js-size-option style-option size p-2 mr-1"
                data-size="small"
                data-price="29.95"
            >
                <strong>13x13 cm</strong>
                <hr class="my-2" />
                <small print-price data-i18n-currency="29.95">€29,95</small>
            </div>
            </div>
        </div>
        <div class="js-toggle-for-material" data-material="tegel">
            <p><strong data-i18n="components.tileOptions.chooseAccessory">Kies een accessoire</strong></p>
            <div class="js-acryl-block mb-4">
                <div class="d-flex mb-3">
                    <div
                        class="js-block-option framed style-option frame-option p-2 mr-1"
                        data-block="black-frame"
                        data-price="14.95"
                    >
                        <img
                        src="https://wallable.nl/wp-content/uploads/builder-images/tegellijst-zwart.webp"
                        class="img-fluid mb-2 mt-0 mx-auto rounded"
                        style="max-height:80px;"
                        />
                        <strong data-i18n="components.tileOptions.blackFrame">Zwarte lijst</strong>
                        <hr class="my-2" />
                        <small class="js-block-price discount-price" data-i18n-currency="14.95">€14,95</small>
                    </div>
                    <div
                        class="js-block-option framed style-option frame-option p-2 mr-1"
                        data-block="oak-frame"
                        data-price="14.95"
                    >
                        <img
                        src="https://wallable.nl/wp-content/uploads/builder-images/tegellijst-eiken.webp"
                        class="img-fluid mb-2 mt-0 mx-auto rounded"
                        style="max-height:80px;"
                        />
                        <strong data-i18n="components.tileOptions.oakFrame">Eiken lijst</strong>
                        <hr class="my-2" />
                        <small class="js-block-price discount-price" data-i18n-currency="14.95">€14,95</small>
                    </div>
                </div>
                <div class="d-flex">
                    <div
                        class="js-block-option framed style-option frame-option p-2 mr-1"
                        data-block="black"
                        data-price="6.95"
                    >
                        <img
                        src="https://wallable.nl/wp-content/uploads/2026/02/tegelhouder-zwart.webp"
                        class="img-fluid mb-2 mt-0 mx-auto rounded"
                        style="max-height:80px;"
                        />
                        <strong data-i18n="components.tileOptions.blackStand">Zwarte houder</strong>
                        <hr class="my-2" />
                        <small class="js-block-price discount-price" data-i18n-currency="6.95">€6,95</small>
                        <span class="badge loved mt-2 mx-auto" data-i18n="components.productOptions.mostPopular">Meest gekozen</span>
                    </div>
                    <div
                        class="js-block-option framed style-option frame-option p-2 mr-1"
                        data-block="oak"
                        data-price="6.95"
                    >
                        <img
                        src="https://wallable.nl/wp-content/uploads/2026/02/tegelhouder-eiken.webp"
                        class="img-fluid mb-2 mt-0 mx-auto rounded"
                        style="max-height:80px;"
                        />
                        <strong data-i18n="components.tileOptions.oakStand">Eiken houder</strong>
                        <hr class="my-2" />
                        <small class="js-block-price discount-price" data-i18n-currency="6.95">€6,95</small>
                    </div>
                </div>
                <div
                    class="js-block-option style-option frame-option mt-3 p-1 mr-1"
                    data-block="no-block"
                    data-price="0"
                >
                    <span data-i18n="components.tileOptions.noAccessory">Zonder accessoire</span>
                </div>
            </div>
        </div>
    `;
  }
}

customElements.define("tegel-options", TegelOptions);
